<template>
  <div id="dashboard" class="content">
    <div class="row">
      <div class="col-12">
        <a class="block block-rounded" href="javascript:void(0)">
          <div class="block-header block-header-default">
            <h3 class="block-title">总营收</h3>
          </div>
          <div class="block-content block-content-full">
            <div class="row text-center">
              <div class="col-12"></div>
              <div class="col-4">
                <div class="py-0">
                  <p
                    class="font-size-125 font-w300 mb-0"
                  >{{(stats && changeTwoDecimal(stats.cal.yesterdayChangeMoney)) || '--'}}</p>
                  <p class="text-muted mb-0 font-size-75">{{duration.startDate}}</p>
                </div>
              </div>
              <div class="col-4">
                <div class="py-0">
                  <p
                    class="font-size-125 font-w300 mb-0"
                  >{{(stats && changeTwoDecimal(stats.cal.sumChangeMoney)) || '--'}}</p>
                  <p class="text-muted mb-0 font-size-75">{{duration.label}}</p>
                </div>
              </div>
              <div class="col-4">
                <div class="py-0">
                  <p
                    class="font-size-125 font-w300 mb-0"
                    v-html="(stats && compare(stats.cal.seqChangeMoney)+'')  || '--'"
                  ></p>
                  <p class="text-muted mb-0 font-size-75">环比</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div id="chart-degree" style="width: 100%; height: 200px"></div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-12" style="margin-bottom: 10px;">
      <div class="row mb-2 mt-4" style="margin-right: -64px;">
        <div class="col-6 row">
          <h2 class="h3 font-w400 mb-0 line-height">{{localSelect}}营收数据</h2>
        </div>
        <div class="col-6 text-right mr-0">
          <screenTime :isToday="'1'" @changePage="changePage"></screenTime>
        </div>
      </div>
    </div>
    <div class="block block-rounded block-bordered">
      <div class="block-header block-header-default">
        <h3 class="block-title">{{ '时间范围： ' + duration.startDate + ' 至 ' + this.duration.endDate }}</h3>
        <div class="block-options">
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>
      <div class="block-content block-content-full">
        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
          <div class="row mb-1">
            <div class="col-12 col-md-4 text-center text-md-left">
              <pageSize @changePageSize="changePageSize"></pageSize>
            </div>
            <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
              <div class="dt-buttons">
                <button
                  class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  tabindex="0"
                  aria-controls="DataTables_Table_1"
                  data-clipboard-text
                  @click="copy()"
                  type="button"
                  id="copybtn"
                >
                  <span>复制</span>
                </button>
                <button
                  class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  @click="exportCSV()"
                  type="button"
                >
                  <span>导出</span>
                </button>
                <button
                  class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                  @click="print()"
                >
                  <span>打印</span>
                </button>
              </div>
            </div>
            <div class="col-12 col-md-4 text-center text-md-right">
              <div class="dataTables_filter">
                <label>
                  <input
                    type="search"
                    class="form-control"
                    placeholder="搜索"
                    v-model="key"
                    @keyup.enter="search()"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive">
                <section ref="print">
                  <p class="show-on-print print-title">{{localSelect}}营收数据</p>
                  <p
                    class="show-on-print print-subheading"
                  >{{ '时间范围： ' + duration.startDate + ' 至 ' + this.duration.endDate }}</p>
                  <table
                    class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                  >
                    <thead>
                      <tr>
                        <th
                          class="text-center sorting"
                          style="width: 60px; min-width:60px"
                          @click="getList('DATE_TIME',$event)"
                        >#</th>
                        <th
                          class="text-left sorting"
                          style="width:120px;min-width:120px;"
                          @click="getList('DATE_TIME',$event)"
                        >日期</th>
                        <th
                          class="text-left sorting"
                          style="width:150px;min-width:150px;"
                          @click="getList('CELL_NAME',$event)"
                        >小区名称</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:100px;"
                          @click="getList('SITE_COUNT',$event)"
                        >站点数量</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:100px;"
                          @click="getList('CARPORT_COUNT',$event)"
                        >车棚数量</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:100px;"
                          @click="getList('PORT_COUNT',$event)"
                        >端口数量</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:110px;"
                          @click="getList('ARPU_FEE',$event)"
                        >端口ARPU</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:100px;"
                          @click="getList('CHARGE_FEE',$event)"
                        >充电收入</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:100px;"
                          @click="getList('CARPORT_FEE',$event)"
                        >停车收入</th>
                        <th
                          class="text-left sorting"
                          style="width:105px;min-width:105px;"
                          @click="getList('TOTAL_FEE',$event)"
                        >总营收</th>
                      </tr>
                    </thead>
                    <tbody v-if=" incomeList.length">
                      <tr v-for="(item, i) in  incomeList" :key="i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-left">{{ item.DATE_TIME }}</td>
                        <td class="text-left d-md-table-cell">{{ item.CELL_NAME }}</td>
                        <td class="text-left d-md-table-cell">{{ item.SITE_COUNT }}</td>
                        <td class="text-left d-md-table-cell">{{ item.CARPORT_COUNT }}</td>
                        <td class="text-left d-md-table-cell">{{ item.PORT_COUNT }}</td>
                        <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.ARPU_FEE) }}</td>
                        <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.CHARGE_FEE) }}</td>
                        <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.CARPORT_FEE ) }}</td>
                        <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.TOTAL_FEE) }}</td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td class="text-center" colspan="12">查无数据</td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
              <div class="dataTables_info" role="status" aria-live="polite">
                页数
                <strong>{{ page }}</strong> /
                <strong>{{ totalPage }}</strong>
              </div>
            </div>
            <div class="col-sm-12 col-md-7 text-center text-md-right">
              <div class="dataTables_paginate paging_full_numbers">
                <el-pagination
                  v-if=" incomeList &&  incomeList.length"
                  @current-change="handleCurrentChange"
                  :current-page="page"
                  :page-size="pageSize"
                  :pager-count="pagerCount"
                  :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                  :small="isMobile"
                  :total="total"
                  background
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 引入基本模板
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/pie");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
require("echarts/lib/chart/map");
import Util from "../../../../Util.js";
import screenTime from "../../../../components/screenTime";
import pageSize from "../../../../components/pageSize";

export default {
  name: "index",
  data() {
    return {
      incomeList: [],
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      clipboard: null,
      sorting: "",
      orderBy: false,
      totalList: [],
      agents: [],
      stats: null,
      charts: [],
      entryUrl: "",
      url: "",
      listUrl: ""
    };
  },
  components: {
    screenTime,
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    params() {
      return this.$store.state.params;
    },
    regionParams() {
      return this.$store.state.regionParams;
    },
    localSelect() {
      return this.$store.state.localSelect;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
          this.getEchart();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    if (this.$route.params.type) {
      this.$store.commit("setParam", {
        params: this.$route.params
      });
    }
    this.listUrl = Util.getDifferentRolesUrl(
      this,
      "Statistics/ListByIncomeLayerByCity"
    );
    // 折线图
    this.entryUrl = Util.getDifferentRolesUrl(this, "SearchES/Stat");
    let that = this;
    window.onresize = function() {
      setTimeout(_ => {
        that.resizeCharts();
      }, 500);
    };
    // this.getEntry()
    this.getList();
    this.copy();
    this.getEchart();
  },
  methods: {
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    changePage(val) {
      this.page = val;
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    compare: val => {
      let modifier = val > 0 ? "+ " : "";
      let color = val > 0 ? "green" : "red;";
      return `<div style="color: ${color}">${modifier}${val}${
        val == "-" ? "" : "%"
      }</div>`;
    },
    resizeCharts() {
      for (let i = 0; i < this.charts.length; i++) {
        const chart = this.charts[i];
        chart.resize();
      }
    },
    selectVal(ele) {
      this.selected = ele.target.value;
    },
    getEchart() {
      this.$http
        .get(
          `${this.entryUrl}${this.duration.startDate}/${this.duration.endDate}?region=${this.regionParams.region}&object=${this.regionParams.object}`
        )
        .then(result => {
          console.log(result);
          if (result.data.data) {
            this.stats = result.data.data;
            $(function() {
              Dashmix.helpers([
                "easy-pie-chart",
                "sparkline",
                "datepicker",
                "flatpickr"
              ]);
            });
            $(".js-dataTable-buttons").DataTable();
            $(".js-dataTable-buttons")
              .DataTable()
              .clear();
            const dates = _.map(this.stats.log, x => x.statistics_date);
            setTimeout(() => {
              Util.initChart(
                this,
                "chart-degree",
                dates,
                _.map(this.stats.log, x => x.change_money),
                "#FFB119",
                "line",
                "元"
              );
            }, 500);
          }
        });
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }
      this.$http
        .get(
          `${this.listUrl}${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.incomeList = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${this.listUrl}${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      var btn = document.getElementById("copybtn");
      btn.setAttribute("data-clipboard-text", copyStr);
      var clipboard = new ClipboardJS(btn);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();

        e.clearSelection();
      });
    }
  }
};
</script>
<style scoped lang="less">
.badge {
  font-weight: 400 !important;
}
.custom-control-inline {
  margin-right: 3rem;
}
.custom-control {
  label {
    font-size: 0.9375rem;
    font-weight: 400;
  }
}
</style>